window.ALANI_ORIGIN_PRODUCT_DATA = {
  'mini-energy-cherry-twist-24-pack-q7': {
    image: 'https://alantrinu.shop/cdn/shop/files/stretch_AN-Website-8.4oz-PDP-CHT-01_v1.png?v=1784914539',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/stretch_AN-Website-8.4oz-PDP-CHT-01_v1.png?v=1784914539',
      'https://alantrinu.shop/cdn/shop/files/stretch_AN-Website-8.4oz-PDP-CHT-02_v1.png?v=1784914539',
      'https://alantrinu.shop/cdn/shop/files/stretch_AN-Website-8.4oz-PDP-CHT-03_v1.png?v=1784914539',
      'https://alantrinu.shop/cdn/shop/files/stretch_AN-Website-8.4oz-PDP-CHT-04_v1.jpg?v=1784914539',
      'https://alantrinu.shop/cdn/shop/files/stretch_AN-Website-8.4oz-PDP-CHT-05-Lifestyle_v1.jpg?v=1784914539'
    ]
  },
  'pre-workout-burn-melonberry-blast-30-servings-i9': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-MBB-01_V1.png?v=1784914435',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-MBB-01_V1.png?v=1784914435',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-MBB-02_V1.png?v=1784914435',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-MBB-03_V1.png?v=1784914435',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-MBB-04_V1.jpg?v=1784914435'
    ]
  },
  'pre-workout-burn-dragon-fruit-rush-30-servings-z4': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-DFR-01_V1.png?v=1784914441',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-DFR-01_V1.png?v=1784914441',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-DFR-02_V1.png?v=1784914441',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-DFR-03_V1.png?v=1784914441',
      'https://alantrinu.shop/cdn/shop/files/Stetch_AN-Website-30serv-PWOplus-PDP-DFR-04_V1.jpg?v=1784914440'
    ]
  },
  'pre-workout-juicy-peach-30-servings-u5': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PCH-01_V2.png?v=1784914462',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PCH-01_V2.png?v=1784914462',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PCH-02_V2.png?v=1784914462',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PCH-03_V2.png?v=1784914462',
      'https://alantrinu.shop/cdn/shop/files/old_ProductPagePWOLifestyle1_44f7d253-f408-4686-9d6d-5c3a4254c49c.jpg?v=1784914461',
      'https://alantrinu.shop/cdn/shop/files/old_ProductPagePWOLifestyle2_60c5046e-cc93-498f-b421-2baf2bbb8aea.jpg?v=1784914461',
      'https://alantrinu.shop/cdn/shop/files/old_ProductPagePWOLifestyle3_77022674-d0da-499a-8941-6c66b1f93261.jpg?v=1784914461'
    ]
  },
  'pre-workout-blue-slush-30-servings-w0': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-BSL-01_V1.png?v=1784914472',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-BSL-01_V1.png?v=1784914472',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-BSL-02_V1.png?v=1784914472',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-BSL-03_V1.png?v=1784914472',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-BSL-04_V1.jpg?v=1784914472',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-BSL-05_V1.jpg?v=1784914471'
    ]
  },
  'pre-workout-pink-slush-30-servings-q7': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PSL-01_V2.png?v=1784914497',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PSL-01_V2.png?v=1784914497',
      'https://alantrinu.shop/cdn/shop/files/AN-Website-30serv-PWO-PDP-PSL-02_V2.png?v=1784914497',
      'https://alantrinu.shop/cdn/shop/files/AN-Website-30serv-PWO-PDP-PSL-03_V2.png?v=1784914498',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PSL-04_V1.jpg?v=1784914497',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-PSL-05_V1.jpg?v=1784914497'
    ]
  },
  'pre-workout-orange-kiss-30-servings-z6': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-ORK-01_V2.png?v=1784914507',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-ORK-01_V2.png?v=1784914507',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-ORK-02_V2.png?v=1784914507',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-ORK-03_V2.png?v=1784914507',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-ORK-05_V1.jpg?v=1784914506'
    ]
  },
  'pre-workout-cherry-twist-30-servings-x2': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-CHT-01_V2.png?v=1784914513',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-CHT-01_V2.png?v=1784914513',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-CHT-02_V2.png?v=1784914513',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-CHT-03_V2.png?v=1784914513',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-CHT-04_V2.jpg?v=1784914512',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWO-PDP-CHT-05_V2.jpg?v=1784914512'
    ]
  },
  'pre-workout-frozen-lemonade-30-servings-r0': {
    image: 'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-FZL-01_V1.png?v=1784914604',
    gallery: [
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-FZL-01_V1.png?v=1784914604',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-FZL-02_V1.png?v=1784914605',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-FZL-03_V1.png?v=1784914604',
      'https://alantrinu.shop/cdn/shop/files/Stretch_AN-Website-30serv-PWOplus-PDP-FZL-05_V1.jpg?v=1784914604'
    ]
  },
  'gift-card-t4': {
    image: 'https://alantrinu.shop/cdn/shop/files/Artboard8copy_1_2048x2048_8ff409c1-b375-4d5a-93e3-9ec5b2403939.png?v=1784914410',
    gallery: ['https://alantrinu.shop/cdn/shop/files/Artboard8copy_1_2048x2048_8ff409c1-b375-4d5a-93e3-9ec5b2403939.png?v=1784914410']
  }
};
